import { useLocation } from "react-router-dom"
import CreateEditTotals from "../Components/CreateEditTotals"

const CreateEditOutputGrandTotals = () => {
  const location = useLocation()
  return <CreateEditTotals location={location} />
}
export default CreateEditOutputGrandTotals
